export default __webpack_public_path__ + "img/dJqKDdYv.5dc67b82.svg";